/* eslint-disable no-undef,no-console,react/no-danger,no-unused-vars,max-len,react/prop-types */
import React from 'react';
import ImageGallery from 'react-image-gallery';
import PropTypes from 'prop-types';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase';
import { Link } from 'gatsby';
import queryString from 'query-string';
import SEO from '../../components/seo';
import './style.scss';
import Layout from '../../components/Layout';
import NavBar from '../../components/NavBar';
import SubscribeMailingList from '../../components/SubscribeMailingList';
import Footer from '../../components/Footer';
import ShoppingCartContext from '../../components/ShoppingCart/shopping-cart-context';
import OtherSimilarProducts from '../../components/OtherSimilarProducts';
import getCloudinary from '../../utils/getCloudinary';
import getIsWholesaleAccount from '../../utils/getIsWholesaleAccount';

// eslint-disable-next-line react/prop-types
const ProductPage = ({ pageContext: product }) => {
    const sortedAlphabeticallyVariants = product.variants.sort(
        (a, b) => +(a.name > b.name) || -(a.name < b.name),
    );
    const [quantity, setQuantity] = React.useState(1);
    const [selectedVariant, setSelectedVariant] = React.useState(sortedAlphabeticallyVariants[0]);
    const [addedToCart, setAddedToCart] = React.useState(false);
    const [isWholesaleAccount, setIsWholesaleAccount] = React.useState(false);
    const {
        addToCart,
    } = React.useContext(ShoppingCartContext);
    const [authUser, initialising, error] = typeof window !== 'undefined' ? useAuthState(firebase.auth()) : Array(3);

    React.useEffect(() => {
        const querySelectedVariant = sortedAlphabeticallyVariants.find(
            // eslint-disable-next-line no-restricted-globals
            variant => variant.name === queryString.parse(location.search).selected,
        );

        if (querySelectedVariant) {
            setSelectedVariant(querySelectedVariant);
        }
    }, []);

    React.useEffect(() => {
        let isWholesaleAccountTemp = false;
        if (authUser) {
            const checkIsWholesale = async () => {
                const wholesaleResult = await getIsWholesaleAccount();

                isWholesaleAccountTemp = wholesaleResult;
                setIsWholesaleAccount(isWholesaleAccountTemp);
            };

            checkIsWholesale();
        }

        if (process.env.GATSBY_ACTIVE_ENV === 'production' && !initialising) {
            gtag('event', 'view_item', {
                items: [{
                    id: selectedVariant.id,
                    name: product.name,
                    brand: 'Dr Watson',
                    category: product.productgroup.name,
                    variant: selectedVariant.name,
                    price: isWholesaleAccountTemp ? selectedVariant.wholesale_price : selectedVariant.price,
                }],
            });
        }
    });

    let screenWidth = 0;
    if (typeof window !== 'undefined') {
        screenWidth = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
    }

    return (
        <Layout id="product-page">
            <SEO title={product.name} />
            <NavBar showSmallLogo />
            <div className="nav-bar-below-content is-centered">

                <div className="columns product-detail is-marginless">
                    <div className="column is-full-tablet is-half-desktop ">
                        <ImageGallery
                            showFullscreenButton={false}
                            showPlayButton={false}
                            showThumbnails={selectedVariant.images.length > 1}
                            thumbnailPosition={screenWidth < 1024 ? 'bottom' : 'left'}
                            items={
                                selectedVariant
                                    .images
                                    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                                    .map(
                                        (image) => {
                                            const imageURL = getCloudinary().url(
                                                image.public_id,
                                                { height: 500, crop: 'fit', fetch_format: 'auto' },
                                            );
                                            return {
                                                original: imageURL,
                                                thumbnail: imageURL,
                                            };
                                        },
                                    )}
                        />
                    </div>
                    <div className="column is-full-mobile is-half-desktop is-one-third-widescreen">
                        <div className="product-title title is-size-3-touch is-size-2-desktop">{product.name}</div>
                        {
                            product.productgroup.name !== product.name
                            && (
                                <div className="product-type subtitle is-size-5-touch is-size-4-desktop">{product.productgroup.name}</div>
                            )
                        }
                        <div
                            className="product-price title is-size-6-touch is-size-5-desktop"
                        >
                            {`£${isWholesaleAccount ? selectedVariant.wholesale_price : selectedVariant.price} (incl. VAT)`}
                        </div>

                        <div
                            className="description content is-size-6-touch is-size-5-desktop"
                            dangerouslySetInnerHTML={{
                                __html:
                                    selectedVariant.description
                                    && selectedVariant.description.length > 0
                                        ? selectedVariant.description
                                        : product.description,

                            }}
                        />

                        <Link
                            to="shipping-and-returns"
                            className="shipping-and-returns-link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Shipping & Returns Information
                        </Link>

                        {
                            sortedAlphabeticallyVariants.length > 1 && (
                                <VariantDropdown
                                    selectedVariant={selectedVariant}
                                    variants={sortedAlphabeticallyVariants}
                                    onSelect={setSelectedVariant}

                                />
                            )
                        }

                        <QuantityDropdown
                            selectedQuantity={quantity}
                            maxQuantity={20}
                            onSelect={setQuantity}
                        />

                        <button
                            type="button"
                            className={`add-to-cart-button button has-text-white ${addedToCart ? 'is-theme-info' : 'is-theme-success'}`}
                            onClick={() => {
                                const cleanedProduct = { ...product };
                                delete cleanedProduct.otherProducts;

                                addToCart({
                                    product: {
                                        ...cleanedProduct,
                                        variant: selectedVariant,
                                    },
                                    quantity,
                                });
                                setAddedToCart(true);
                                setTimeout(() => {
                                    setAddedToCart(false);
                                }, 1000);
                            }}
                        >
                            {addedToCart
                                ? (
                                    <div className="is-flex is-vertical">
                                        Added To Cart
                                        <i className="fas fa-check" style={{ marginLeft: '10px' }} />
                                    </div>
                                )
                                : 'Add To Cart'}
                        </button>
                        {/* <button type="button" className="checkout-button button is-primary">Checkout Now</button> */}
                        {/* <button */}
                        {/* type="button" */}
                        {/* className="checkout-button button is-info is-size-6-touch is-size-5-desktop" */}
                        {/* onClick={() => { */}
                        {/* const elem = document.getElementsByClassName('subscribe-mailing-list-container'); */}
                        {/* console.log(elem); */}
                        {/* // eslint-disable-next-line no-undef */}
                        {/* if (elem.length > 0) { */}
                        {/* // eslint-disable-next-line no-undef */}
                        {/* window.scrollTo({ */}
                        {/* top: elem[0].offsetTop, */}
                        {/* behavior: 'smooth', */}
                        {/* }); */}
                        {/* } */}
                        {/* }} */}
                        {/* > */}
                        {/* Receive email when online store is live */}
                        {/* </button> */}
                    </div>
                </div>

                {product.otherProducts.length > 0 && (
                    <OtherSimilarProducts products={product.otherProducts} />
                )}
                <SubscribeMailingList />
                <Footer />
            </div>
        </Layout>
    );
};

ProductPage.propTypes = {
    pageContext: PropTypes.shape({
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        slug: PropTypes.string.isRequired,
        variant: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
            price: PropTypes.number,
            images: PropTypes.arrayOf(
                PropTypes.shape({
                    createdAt: PropTypes.string,
                    url: PropTypes.string,
                }),
            ),
        }).isRequired,
    }).isRequired,
};


const VariantDropdown = ({ selectedVariant, variants, onSelect }) => (
    <div className="variant-dropdown">
        {
            variants
                .sort((a, b) => +(a.name > b.name) || -(a.name < b.name))
                .map(variant => (
                    <div
                        key={variant.name}
                        className={`
                        variant-dropdown-item ${
                    selectedVariant === variant && 'is-theme-info has-text-white has-text-weight-semibold is-selected'
                    } is-size-6-touch is-size-5-desktop is-flex align-items-center
                     `}
                        onClick={() => {
                            onSelect(variant);
                        }}
                    >
                        <i className="fas fa-check-circle mr-1" />
                        <div>{variant.name}</div>
                    </div>
                ))
        }
    </div>
);

VariantDropdown.propTypes = {
    selectedVariant: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }).isRequired,

    variants: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }).isRequired,

    onSelect: PropTypes.func.isRequired,
};

const QuantityDropdown = ({
    selectedQuantity, minQuantity, maxQuantity, onSelect,
}) => (
    <div className="quantity-dropdown dropdown">
        <div className="dropdown-trigger">
            <button
                className="button"
                aria-haspopup="true"
                aria-controls="dropdown-menu2"
                type="button"
                onClick={() => {
                    const dropdown = document.querySelector('.quantity-dropdown');
                    dropdown.classList.toggle('is-active');
                }}
            >
                <span className="is-size-6-touch is-size-5-desktop has-text-weight-semibold">{`QTY: ${selectedQuantity}`}</span>
                <span className="icon is-small">
                    <i className="fas fa-angle-down" aria-hidden="true" />
                </span>
            </button>
        </div>
        <div
            className="full-page-overlay"
            onClick={() => {
                const dropdown = document.querySelector('.quantity-dropdown');
                dropdown.classList.remove('is-active');
            }}
        />
        <div className="dropdown-menu" id="dropdown-menu2" role="menu">
            <div className="dropdown-content">
                {
                    Array(maxQuantity - minQuantity + 1)
                        .fill()
                        .map((_, idx) => minQuantity + idx)
                        .map(q => (
                            <div
                                className="dropdown-item"
                                onClick={() => {
                                    onSelect(q);
                                    const dropdown = document.querySelector('.quantity-dropdown');
                                    dropdown.classList.toggle('is-active');
                                }}
                            >
                                {q}
                            </div>
                        ))
                }
            </div>
        </div>
    </div>
);

QuantityDropdown.defaultProps = {
    minQuantity: 1,
};

QuantityDropdown.propTypes = {
    selectedQuantity: PropTypes.number.isRequired,
    minQuantity: PropTypes.number,
    maxQuantity: PropTypes.number.isRequired,
    onSelect: PropTypes.func.isRequired,
};


export default ProductPage;
